import {request} from '../http';
import domain    from '../domain';

let parkService = function(){
        if( domain.env === 'online' ){
            this.domain = '//park.51tiangou.com';
        }
        else{
            this.domain = '//park.' + domain.env + '.66buy.com.cn';
        }
    }
    ;

// 查询缴费记录
parkService.prototype.queryPayDetails = function(params){
	let that = this
        ;

	params.type = 'POST';
	that._serviceAjaxCom('/publics/parkPay/queryPayDetails', params);
};

// 查询缴费记录
parkService.prototype.queryPayDetail = function(params){
	let that = this
        ;

	params.type = 'POST';
	that._serviceAjaxCom('/publics/parkPay/queryPayDetail', params);
};

// 添加爱车
parkService.prototype.addCar = function(params){
	let that = this
        ;

	params.type = 'POST';
	that._serviceAjaxCom('/publics/parkCar/addCar', params);
};

// 删除爱车
parkService.prototype.deleteCar = function(params){
	let that = this
        ;

	params.type = 'POST';
	that._serviceAjaxCom('/publics/parkCar/deleteCar', params);
};

// 提交反馈问题
parkService.prototype.submitParkQuestion = function(params){
	let that = this
        ;

	params.type = 'POST';
	that._serviceAjaxCom('/publics/parkCar/submitParkQuestion', params);
};

// 查询停车场的Q&A
parkService.prototype.queryQA = function(params){
	let that = this
        ;

	params.type = 'POST';
	that._serviceAjaxCom('/publics/parkCar/queryQA', params);
};

// 查询缴费详情
parkService.prototype.queryPayDetail = function(params){
	let that = this
        ;

	params.type = 'POST';
	that._serviceAjaxCom('/publics/parkPay/queryPayDetail', params);
};

// 查询停车支付反馈问题
parkService.prototype.feedBackQuestions = function(params){
	let that = this
        ;

	params.type = 'POST';
	that._serviceAjaxCom('/publics/parkCar/feedBackQuestions', params);
};

parkService.prototype.payOptions = function(params){
	let that = this
        ;

	params.type = 'POST';
	that._serviceAjaxCom('/publics/parkPay/payOptions', params);
};

parkService.prototype.commit = function(params){
	let that = this
        ;

	params.type = 'POST';
	that._serviceAjaxCom('/publics/parkPay/payOptions/commit', params);
};

parkService.prototype._serviceAjaxCom = function(url, params){
	params.url = this.domain + url;

	return request( params );
};

/**
 * 2021-08-20
 * 激活
 * */
parkService.prototype.activeCar = function(params){
    params.type = 'POST';

    return this._serviceAjaxCom('/publics/parkCar/activeCar', params);
};

export default new parkService();